export const GERMAN_UI_TRANSLATIONS: Record<string, string> = {
  'English': 'Englisch',
  'German': 'Deutsch',
  'Switch language': 'Sprache wechseln',
  'Login': 'Anmelden',
  'Register': 'Registrieren',
  'Logout': 'Abmelden',
  'Profile': 'Profil',
  'Administrator': 'Administrator',
  'Manager': 'Manager',
  'Team Member': 'Teammitglied',
  'Home': 'Startseite',
  'Questionnaire': 'Fragebogen',
  'User Administration': 'Benutzerverwaltung',
  'Here you can manage all users. You can add, edit and delete users.': 'Hier können Sie alle Benutzer verwalten sowie Benutzer hinzufügen, bearbeiten und löschen.',
  'No users with manager role found': 'Keine Benutzer mit der Rolle „Manager“ gefunden',
  'Departments': 'Abteilungen',
  'Manage all departments and their members.': 'Verwalten Sie alle Abteilungen und deren Mitglieder.',
  'Member': 'Mitglied',
  'Created at:': 'Erstellt am:',
  'Department Details': 'Abteilungsdetails',
  'Update Manager': 'Abteilungsleitung aktualisieren',
  'Managers without department': 'Manager ohne Abteilung',
  'Delete Department': 'Abteilung löschen',
  'Edit Department': 'Abteilung bearbeiten',
  'See Details': 'Details anzeigen',
  'No departments found': 'Keine Abteilungen gefunden',
  'The department “{name}” has no members.': 'Die Abteilung „{name}“ hat keine Mitglieder.',
  'Confirm deletion': 'Löschen bestätigen',
  'Are you sure you want to remove {user} from the department {department}?': 'Möchten Sie {user} wirklich aus der Abteilung {department} entfernen?',
  'Are you sure you want to delete the department {department}? All members will be removed from it and it cannot be restored.': 'Möchten Sie die Abteilung {department} wirklich löschen? Alle Mitglieder werden aus der Abteilung entfernt und die Abteilung kann nicht wiederhergestellt werden.',
  'Project Teams': 'Projektteams',
  'My Department': 'Meine Abteilung',
  'My Department: {name}': 'Meine Abteilung: {name}',
  'Add New Members': 'Neue Mitglieder hinzufügen',
  'My Project Teams': 'Meine Projektteams',
  'New Project': 'Neues Projekt',
  'You have no projects. Please create one.': 'Sie haben noch keine Projekte. Bitte erstellen Sie eines.',
  'Core': 'Übersicht',
  'Admin': 'Verwaltung',
  'Welcome back, {name}!': 'Willkommen zurück, {name}!',
  'Questionnaire has been answered': 'Der Fragebogen wurde beantwortet',
  'Please fill out the questionnaire completely!': 'Bitte füllen Sie den Fragebogen vollständig aus!',
  'You can view the evaluation of the questionnaire in your': 'Sie können die Auswertung des Fragebogens in Ihrem',
  'Email address': 'E-Mail-Adresse',
  'Password': 'Passwort',
  'Your username is required!': 'Ihre E-Mail-Adresse ist erforderlich!',
  'Your password is required!': 'Ihr Passwort ist erforderlich!',
  'Your password must be at least 8 characters long!': 'Ihr Passwort muss mindestens 8 Zeichen lang sein!',
  'Forgot Password': 'Passwort vergessen',
  'Need an account? Sign up!': 'Noch kein Konto? Jetzt registrieren!',
  'You are already logged in!': 'Sie sind bereits angemeldet!',
  'You must log out before logging in again with different details.': 'Sie müssen sich abmelden, bevor Sie sich mit anderen Zugangsdaten anmelden können.',
  'Cancel': 'Abbrechen',
  'Create Account': 'Konto erstellen',
  'Basic Details': 'Grunddaten',
  'First name': 'Vorname',
  'Last name': 'Nachname',
  'Birth date': 'Geburtsdatum',
  'Job Role': 'Berufsrolle',
  'Your first name is required!': 'Ihr Vorname ist erforderlich!',
  'Your last name is required!': 'Ihr Nachname ist erforderlich!',
  'Your birthday is required!': 'Ihr Geburtsdatum ist erforderlich!',
  'Your job role is required!': 'Ihre Berufsrolle ist erforderlich!',
  'Your email address is required!': 'Ihre E-Mail-Adresse ist erforderlich!',
  'Email address is not valid': 'Die E-Mail-Adresse ist ungültig',
  'Job role is not valid': 'Die Berufsrolle ist ungültig',
  'Confirm Password': 'Passwort bestätigen',
  'Passwords do not match': 'Die Passwörter stimmen nicht überein',
  'Select your role': 'Wählen Sie Ihre Rolle',
  'User': 'Benutzer',
  'ADMIN': 'Administrator',
  'MANAGER': 'Manager',
  'USER': 'Benutzer',
  'Security Specialist': 'Sicherheitsspezialist',
  'Specialist': 'Spezialist',
  'Developer': 'Entwickler',
  'Designer': 'Designer',
  'Please select a role!': 'Bitte wählen Sie eine Rolle!',
  'Have an account? Go to login': 'Sie haben bereits ein Konto? Zur Anmeldung',
  'Please take your time and answer all of the following questions.': 'Bitte nehmen Sie sich Zeit und beantworten Sie alle folgenden Fragen.',
  'Does not apply': 'Trifft nicht zu',
  'Applies': 'Trifft zu',
  'Previous': 'Zurück',
  'Next': 'Weiter',
  'Submit': 'Absenden',
  'Confirm removal': 'Entfernen bestätigen',
  'Are you sure you want to remove “{item}”?': 'Möchten Sie „{item}“ wirklich entfernen?',
  'Confirm delete': 'Löschen bestätigen',
  'Are you sure you want to delete “{item}”?': 'Möchten Sie „{item}“ wirklich löschen?',
  'Confirm': 'Bestätigen',
  'Close': 'Schließen',
  'Unauthorized': 'Nicht autorisiert',
  'Access to this resource is denied.': 'Der Zugriff auf diese Ressource wurde verweigert.',
  'Return to Home': 'Zur Startseite',
  'This requested URL was not found on this server.': 'Die angeforderte URL wurde auf diesem Server nicht gefunden.',
  'Internal Server Error': 'Interner Serverfehler',
  'Legal notice': 'Impressum',
  'All rights reserved': 'Alle Rechte vorbehalten',
  'Liability notice: Despite careful content checks, the operator assumes no liability for the content of external links. The operators of the linked pages are solely responsible for their content.': 'Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle übernimmt die Betreiberin dieser Website keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.',
  'Error joining department!': 'Fehler beim Beitritt zur Abteilung!',
  'Your invitation might have been withdrawn or you are already a member of the department.': 'Ihre Einladung wurde möglicherweise zurückgezogen oder Sie sind bereits Mitglied der Abteilung.',
  'Access denied!': 'Zugriff verweigert!',
  'Please log in to accept the invitation!': 'Bitte melden Sie sich an, um die Einladung anzunehmen!',
  'Success': 'Erfolg',
  'You have successfully joined the department.': 'Sie sind der Abteilung erfolgreich beigetreten.',
  'Search ...': 'Suchen ...',
  'Save': 'Speichern',
  'Create': 'Erstellen',
  'Update': 'Aktualisieren',
  'Edit': 'Bearbeiten',
  'Delete': 'Löschen',
  'Remove': 'Entfernen',
  'Name': 'Name',
  'Name / Email': 'Name / E-Mail',
  'Department': 'Abteilung',
  'Role': 'Rolle',
  'Info': 'Info',
  'Actions': 'Aktionen',
  'Members': 'Mitglieder',
  'No users found': 'Keine Benutzer gefunden',
  'No members found': 'Keine Mitglieder gefunden',
  'Birth Date': 'Geburtsdatum',
  'Jobrole': 'Berufsrolle',
  'Invited': 'Eingeladen',
  'Send Invite': 'Einladung senden',
  'Resend Invite': 'Einladung erneut senden',
  'Revoke Invite': 'Einladung widerrufen',
  'Pending Invites': 'Ausstehende Einladungen',
  'Add Member': 'Mitglied hinzufügen',
  'Details': 'Details',
  'Update Name': 'Namen aktualisieren',
  'Create Department': 'Abteilung erstellen',
  'Department Name': 'Name der Abteilung',
  'The name of your department is required!': 'Der Name Ihrer Abteilung ist erforderlich!',
  'You have no department assigned yet. Please create one by giving your department a name.': 'Ihnen ist noch keine Abteilung zugewiesen. Bitte erstellen Sie eine Abteilung und geben Sie ihr einen Namen.',
  'Your department has no members! Please add members by inviting them to your department!': 'Ihre Abteilung hat noch keine Mitglieder. Bitte laden Sie Mitglieder in Ihre Abteilung ein!',
  'Invite registered users from the following table to your department. You can then find them under Pending Invites until the invitation expires or the user accepts it.': 'Laden Sie registrierte Benutzer aus der folgenden Tabelle in Ihre Abteilung ein. Sie finden sie anschließend unter „Ausstehende Einladungen“, bis die Einladung abläuft oder angenommen wird.',
  'Manage pending invitations — resend or revoke them as needed. Invitations expire after 3 weeks.': 'Verwalten Sie ausstehende Einladungen – senden Sie sie erneut oder widerrufen Sie sie bei Bedarf. Einladungen laufen nach 3 Wochen ab.',
  'Projects': 'Projekte',
  'Project': 'Projekt',
  'Create Project': 'Projekt erstellen',
  'Project Name': 'Projektname',
  'Project Members': 'Projektmitglieder',
  'Compare': 'Vergleichen',
  'Compare Projects': 'Projekte vergleichen',
  'Compare with another team...': 'Mit einem anderen Team vergleichen ...',
  'First Name': 'Vorname',
  'Last Name': 'Nachname',
  'No members added': 'Keine Mitglieder hinzugefügt',
  'Add new members': 'Neue Mitglieder hinzufügen',
  'Try to generate an optimal team': 'Versuchen, ein optimales Team zu erstellen',
  'Number of Members:': 'Anzahl der Mitglieder:',
  'Select number of members': 'Mitgliederanzahl wählen',
  'Job Role for Member {number} (optional):': 'Berufsrolle für Mitglied {number} (optional):',
  'Optimal Scores:': 'Optimale Werte:',
  'required, 0–30': 'erforderlich, 0–30',
  'Suggested Team Members:': 'Vorgeschlagene Teammitglieder:',
  'Loading...': 'Wird geladen ...',
  'Create Optimal Team': 'Optimales Team erstellen',
  'Fill Up with Optimal Team': 'Mit optimalem Team auffüllen',
  'Create Optimal Team with AI': 'Optimales Team mit KI erstellen',
  'Fill Up with AI': 'Mit KI-Auswahl auffüllen',
  'No fitting users found': 'Keine passenden Benutzer gefunden',
  'Comparison': 'Vergleich',
  'Trait Differences': 'Unterschiede der Eigenschaften',
  'Neurological Distribution': 'Neurologische Verteilung',
  'Included in both': 'In beiden enthalten',
  'Volitional Facilitation': 'Willensbahnung',
  'Self-Growth': 'Selbstwachstum',
  'Compare to': 'Vergleichen mit',
  'Add members to view assessment': 'Fügen Sie Mitglieder hinzu, um die Auswertung anzuzeigen',
  'The first axis represents volitional facilitation. As the value increases, readiness to act decreases and prospective state orientation increases. Strongly negative values indicate a pronounced lack of self-restraint; strongly positive values indicate a pronounced lack of self-motivation.': 'Die 1. Achse stellt die Willensbahnung dar. Mit steigendem Wert nimmt die Handlungsbereitschaft ab und die prospektive Lageorientierung zu. Stark negative Werte weisen auf einen ausgeprägten Mangel an Selbstbremsung hin; stark positive Werte auf einen ausgeprägten Mangel an Selbstmotivation.',
  'The second axis represents self-growth. As the value increases, conflict avoidance decreases and rigidity increases. Strongly negative values indicate a pronounced lack of self-confrontation; strongly positive values indicate a pronounced lack of self-soothing.': 'Die 2. Achse stellt das Selbstwachstum dar. Mit steigendem Wert nimmt die Konfliktvermeidung ab und die Rigidität zu. Stark negative Werte weisen auf einen ausgeprägten Mangel an Selbstkonfrontationsfähigkeit hin; stark positive Werte auf einen ausgeprägten Mangel an Selbstberuhigung.',
  'Evaluation': 'Auswertung',
  'Assessment': 'Bewertung',
  'Current job role': 'Aktuelle Berufsrolle',
  'Department member': 'Abteilungsmitglied',
  'Department manager': 'Abteilungsleitung',
  'Delete Account': 'Konto löschen',
  'Generating PDF...': 'PDF wird erstellt ...',
  'Download Assessment PDF': 'Auswertung als PDF herunterladen',
  'Assessment Summary': 'Zusammenfassung der Auswertung',
  'Could not export all charts. Please open the assessment and try again.': 'Es konnten nicht alle Diagramme exportiert werden. Bitte öffnen Sie die Auswertung und versuchen Sie es erneut.',
  'Could not generate PDF export right now.': 'Der PDF-Export konnte derzeit nicht erstellt werden.',
  'average': 'Durchschnitt',
  'Relative proportion of the respective trait': 'Relativer Anteil der jeweiligen Eigenschaft',
  'Relative proportion': 'Relativer Anteil',
  'Difference in values': 'Unterschied der Werte',
  'GPT is disabled. Configure a server-side API integration to enable this feature.': 'GPT ist deaktiviert. Konfigurieren Sie eine serverseitige API-Integration, um diese Funktion zu aktivieren.',
  'You can see your assessment here after you have finished the': 'Sie können Ihre Auswertung hier sehen, nachdem Sie den folgenden Fragebogen abgeschlossen haben:',
  'Trait Composition': 'Zusammensetzung der Eigenschaften',
  'Trait Percentages': 'Prozentuale Eigenschaften',
  'Psychological Traits': 'Psychologische Eigenschaften',
  'Process Traits': 'Prozesseigenschaften',
  'Neurological Traits': 'Neurologische Eigenschaften',
  'AI Tips': 'KI-Tipps',
  'AI suggestion:': 'KI-Vorschlag:',
  'You have not started the questionnaire yet': 'Sie haben den Fragebogen noch nicht begonnen',
  'Start Questionnaire': 'Fragebogen starten',
  'This user has not completed the questionnaire yet': 'Dieser Benutzer hat den Fragebogen noch nicht ausgefüllt',
  'Result': 'Ergebnis',
  'Results': 'Ergebnisse',
  'No assessment available yet. Complete the questionnaire first.': 'Noch keine Auswertung verfügbar. Bitte füllen Sie zuerst den Fragebogen aus.',
  'Personal Information': 'Persönliche Informationen',
  'Change Password': 'Passwort ändern',
  'Current Password': 'Aktuelles Passwort',
  'New Password': 'Neues Passwort',
  'Repeat New Password': 'Neues Passwort wiederholen',
  'Reset Password': 'Passwort zurücksetzen',
  'We will send you a reset link if your account exists.': 'Wenn Ihr Konto existiert, senden wir Ihnen einen Link zum Zurücksetzen.',
  'Please select your new password': 'Bitte wählen Sie Ihr neues Passwort',
  'New Password:': 'Neues Passwort:',
  'Confirm Password:': 'Passwort bestätigen:',
  'Apply': 'Übernehmen',
  'Go back to login': 'Zurück zur Anmeldung',
  'First name:': 'Vorname:',
  'Last name:': 'Nachname:',
  'Job role:': 'Berufsrolle:',
  'Birthday:': 'Geburtsdatum:',
  'Email Address:': 'E-Mail-Adresse:',
  'Role:': 'Rolle:',
  'Edit Profile': 'Profil bearbeiten',
  'AI Testing Page': 'KI-Testseite',
  'Prompt': 'Eingabe',
  'Enter prompt': 'Eingabe eingeben',
  'Prompt is required!': 'Eine Eingabe ist erforderlich!',
  'Response:': 'Antwort:',
  'Call GPT': 'GPT aufrufen',
  'Call Custom GPT': 'Benutzerdefiniertes GPT aufrufen',
  'Call Ollama': 'Ollama aufrufen',
  'Our web app with a specially developed assessment — the foundation of every analysis and development.': 'Unsere Webapp mit dem eigens entwickelten Assessment — die Grundlage jeder Analyse und Entwicklung.',
  'Character': 'Charakter',
  'Interaction': 'Interaktion',
  'Potential': 'Potenzial',
  '{answered} of {total} questions answered': '{answered} von {total} Fragen beantwortet',
  'Continue questionnaire': 'Fragebogen fortsetzen',
  'View full evaluation': 'Gesamte Auswertung ansehen',
  'Your strongest process traits': 'Ihre stärksten Prozesseigenschaften',
  'Quick access': 'Schnellzugriff',
  'Learn more about us': 'Mehr über uns',
  'No assessment available yet': 'Noch keine Auswertung verfügbar',
  'Your assessment appears here as soon as you have answered the complete questionnaire.': 'Ihre Auswertung erscheint hier, sobald Sie den vollständigen Fragebogen beantwortet haben.',
};
